module.exports = __webpack_public_path__ + "media/images/home/feature/management_total-88069b98af2ed213cd944f804cd1ea3a.png";